import { render, staticRenderFns } from "./UiTabs.vue?vue&type=template&id=73b6c39e&scoped=true&"
import script from "./UiTabs.vue?vue&type=script&lang=ts&"
export * from "./UiTabs.vue?vue&type=script&lang=ts&"
import style0 from "./UiTabs.vue?vue&type=style&index=0&id=73b6c39e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b6c39e",
  null
  
)

export default component.exports